<template>
    <div class="text-center | md:text-left">
        <!-- Note: the design always starts at step 2 -->
        <div class="text-black font-family-montserrat font-semibold text-xl pb-2 | md:text-3xl md:pb-0" v-if="currentPage < totalPages">
            {{ $t("Stap :currentPage van :totalPages", { currentPage:(currentPage + 1), totalPages: (totalPages+ 1)  }) }}
        </div>

        <span class="text-3xl text-black font-family-montserrat font-semibold " v-if="currentPage === totalPages">
            <svg class="md:inline-block hidden mr-4" xmlns="http://www.w3.org/2000/svg" width="59" height="59" viewBox="0 0 59 59">
                <g id="Group_71" data-name="Group 71" transform="translate(-354 -239)">
                    <g id="Path_24" data-name="Path 24" transform="translate(354 239)" fill="none" stroke-linecap="round" stroke-dasharray="229 300">
                        <path d="M29.5,0A29.6,29.6,0,0,1,54.031,13.109,29.123,29.123,0,0,1,59,29.5,29.5,29.5,0,1,1,29.5,0Z" stroke="none"/>
                        <path d="M 29.5 0 C 39.61756896972656 0 48.54552841186523 5.093387603759766 54.03064346313477 13.10854339599609 C 57.10284423828125 17.59345626831055 59 23.3251838684082 59 29.5 C 59 45.79240036010742 45.79240036010742 59 29.5 59 C 13.20759963989258 59 0 45.79240036010742 0 29.5 C 0 13.20759963989258 13.20759963989258 0 29.5 0 Z M 29.5 53 C 42.45794296264648 53 53 42.45794296264648 53 29.5 C 53 24.8060417175293 51.60807037353516 20.18898391723633 49.0791015625 16.49708557128906 C 44.51381301879883 9.826042175292969 37.37751388549805 6 29.5 6 C 29.5 6 29.5 6 29.5 6 C 16.54205703735352 6 6 16.54205703735352 6 29.5 C 6 42.45794296264648 16.54205703735352 53 29.5 53 Z" stroke="none" fill="#00887f"/>
                    </g>
                    <path id="svg-vink" d="M23.2,2.436a1.826,1.826,0,0,1-.464,1.392c-1.392,1.508-3.016,3.016-4.524,4.64-2.784,2.784-5.568,5.8-8.468,8.468A1.01,1.01,0,0,1,8.7,17.4c-.928,0-1.392-.812-2.436-1.856C4.292,13.572,2.2,11.6.348,9.628A2.092,2.092,0,0,1,0,8.236,2.379,2.379,0,0,1,2.436,5.8a1.66,1.66,0,0,1,1.276.348A65.645,65.645,0,0,1,8.7,11.02c3.6-3.6,7.076-7.192,10.672-10.672A2.092,2.092,0,0,1,20.764,0,2.529,2.529,0,0,1,23.2,2.436Z" transform="translate(372.4 259.8)" fill="#00887f" fill-rule="evenodd"/>
                </g>
            </svg>
            {{ $t("Super! U bent klaar!") }}
        </span>

        <!-- Racetrack + racecar -->
        <ul class="progress-bar-racecar flex flex-row mr-5" :class="{'progress-bar-racecar__backwards': navigationDirection === navigationDirections.BACKWARD}">
            <li :class="{active: pageNumber === currentPage}" v-for="pageNumber in totalPages" :key="pageNumber"></li>
        </ul>
    </div>
</template>
<style lang="scss">
    .progress-bar{
        &-racecar {
            position: relative;
            min-height: 25px;
            //margin-top: 7px;
            //margin-bottom: 32px;
            & li {
                width: 100%;
                font-size: 0;
                position: relative;
                border-bottom: 4px solid #00887F;
                bottom: 1px;
                left: 2px;
                &.active {
                    border-color: #00887F;
                    ~ li {
                        border-bottom: 2px solid #CDCDCD;
                    }
                    ~ li:after {
                        bottom: -4px;
                        background: #CDCDCD;
                    }
                    &:before {
                        content: "";
                        width: 27px;
                        height: 11px;
                        position: absolute;
                        right: -18px;
                        animation-name: moving-car;
                        animation-duration: 1.2s;
                        bottom: 7px;
                        background: url(/plugins/wallbrinkcrossmedia/flitzfunnelquizzes/assets/images/icon-car.svg);
                        background-repeat: no-repeat;
                    }
                    &:last-child:before {
                        right: -33px;
                        bottom: -6px;
                        animation-name: moving-car-finish;
                        animation-duration: 1.2s;
                    }
                    &.active + li:after {
                        background: #00887F;
                    }
                }
                &:after {
                    content: "";
                    position: absolute;
                    bottom: -5px;
                    width: 7px;
                    height: 7px;
                    border-radius: 99px;
                    background: #00887F;
                    left: -3px;
                }
            }
            &__backwards{
                & li {
                    &.active {
                        &:before {
                            animation-name: moving-car-backwards;
                        }
                        &:last-child:before {
                            animation-name: moving-car-finish-backwards;
                        }
                    }
                }
            }
            &:after {
                content: "";
                width: 6px;
                height: 20px;
                position: absolute;
                right: -2px;
                bottom: -8px;
                background: url(/plugins/wallbrinkcrossmedia/flitzfunnelquizzes/assets/images/icon-highway.svg);

            }

        }
    }

    @keyframes moving-car {
        from {right: 100%;}
        to { right: -18px;}
    }
    @keyframes moving-car-finish {
        0%   {
            right: 100%;
            bottom: 7px;
        }
        95%   {
            right: -33px;
            bottom: 7px;
        }
        100%   {
            right: -33px;
            bottom: -6px;
        }
    }

    @keyframes moving-car-backwards {
        0% {
            right: -100%;
            transform: scaleX(1);
        }
        5% {
            right: -100%;
            transform: scaleX(-1);
        }
        95% {
            right: -18px;
            transform: scaleX(-1);
        }
        100% {
            right: -18px;
            transform: scaleX(1);
        }
    }
    @keyframes moving-car-finish-backwards {
        0%   {
            right: -100%;
            bottom: -6px;
            transform: scaleX(1);
        }
        5%   {
            right: -100%;
            bottom: 7px;
            transform: scaleX(-1);
        }
        95%   {
            right: -33px;
            bottom: 7px;
            transform: scaleX(-1);
        }
        100%   {
            right: -33px;
            bottom: 7px;
            transform: scaleX(1);
        }
    }
</style>
<script>
import { useStore } from 'vuex'
import {computed } from "vue";
import {NavigationDirections} from "../../Store/NavigationDirections";
import { wTrans } from 'laravel-vue-i18n';
import { getActiveLanguage } from 'laravel-vue-i18n';

export default {
    name: "ProgressBar",
    components:{

    },
    data() {
        return {

        }
    },
    mounted() {

    },
    setup(props){
        const store = useStore()

        return {
            currentPage: computed(() => store.state.currentPageNumber),
            totalPages: computed(() => store.state.totalPageCount),
            navigationDirection: computed(() => store.state.navigationDirection),
            navigationDirections: NavigationDirections,
        }
    },
    methods:{

    },
    props: {

    }
}
</script>
